function CategoryA() {
    return (
        <div>
            CategoryA
        </div>
    );
}

export default CategoryA;